import { useEffect, useState } from "react";

/**
 * UI preferences only (search text, filter choices, selected project).
 * Never put tokens, credentials or personal data here — auth lives in httpOnly cookies.
 */
export function usePersistentState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw === null ? initial : JSON.parse(raw);
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage full or blocked — preferences just won't persist */
    }
  }, [key, value]);

  return [value, setValue];
}
